import { IChatGroup, IChatOptions } from "@deltasge/marauders-map";

export enum ActionTypes {
  SET = "@chat/Unreads/SET",
}

export enum ActionTypes {
  SETOPTIONS = "@chat/Options/SET",
}

export interface State {
  unreads: IChatGroup[];
  geral: number;
  chat: number;
  mensagens: number;
  options: IChatOptions;
}
